import type { TermKind } from '@zyx/shared';
import { Link, useParams } from 'react-router-dom';
import { PageHeader } from '@/components/common/page-header';
import { ErrorState } from '@/components/common/states';
import { MovieGrid } from '@/components/movie/movie-grid';
import { useTerm } from '@/hooks/use-movies';
import { urls } from '@/lib/urls';

export const TERM_KIND_LABELS: Readonly<Record<TermKind, string>> = { genre: 'Genre', maker: 'Maker', series: 'Series', label: 'Label', tag: 'Tag' };

export function TermPage() {
  const termId = Number(useParams().termId);
  const term = useTerm(termId);
  if (term.isError) {
    return <ErrorState error={term.error} />;
  }
  const found = term.data?.term;
  return (
    <div className="space-y-6">
      <PageHeader
        title={found?.name ?? '…'}
        description={
          found === undefined ? undefined : (
            <>
              <Link to={urls.terms(found.kind)} className="hover:text-foreground hover:underline">
                {TERM_KIND_LABELS[found.kind]}
              </Link>
              {` · ${found.movieCount} movies`}
            </>
          )
        }
      />
      <MovieGrid request={{ termId }} empty={{ title: 'No movies indexed here yet' }} />
    </div>
  );
}
